import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { authModel } from 'models';
import { redirectToSignIn } from 'utils/helpers/urlHelpers';

import { BuilderAuthMessage } from '../BuilderAuthMessage/BuilderAuthMessage';

import { ReactComponent as GoogleIcon } from 'assets/img/google.svg';

export const BuilderAccountNotFound = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onSignUpWithGoogle = () => {
    authModel.redirectToGoogleAuth(authModel.googleFlow.signUp);
  };

  return (
    <BuilderAuthMessage
      tabTitle={t('pages.auth.signInPage.accountNotFound.tabTitle')}
      title={t('pages.auth.signInPage.accountNotFound.builderTabTitle')}
      text={<Trans i18nKey="pages.auth.signInPage.accountNotFound.builderText" />}
      buttonText={t('pages.auth.signUpPage.googleSignUpBtn')}
      onBack={redirectToSignIn}
      onButtonClick={onSignUpWithGoogle}
      buttonIcon={GoogleIcon}
      buttonVariant="outlined"
    />
  );
};
